module.exports = __webpack_public_path__ + "media/images/top/howto-02-6493c468f1da24a5c63de6dc6c29ff24.svg";